import BOUNDARY_DEFS from './data/boundary_defs.json' with { type: 'json' };
export function getBoundaryItem(variant) {
    if (!(variant in BOUNDARY_DEFS)) {
        throw new Error('Unknown boundary variant: ' + variant);
    }
    const item = BOUNDARY_DEFS[variant];
    return item;
}
//# sourceMappingURL=boundary.js.map